module.exports = __webpack_public_path__ + "static/img/reserve-the-property.f5f9bce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reserve-the-property.jpg
// module id = c+IW
// module chunks = 0